var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHockey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0303 26.1695C29.4765 25.2603 28.2871 24.9801 27.3779 25.5338C27.3642 25.5406 25.7099 26.443 23.1533 25.3902C22.791 25.2467 22.415 25.2125 22.0596 25.2808L18.9834 19.9557L26.3183 7.26131C26.6738 6.64608 26.4619 5.85995 25.8467 5.50448C25.2314 5.14901 24.4453 5.36092 24.0898 5.97616L17.4931 17.3922L10.8965 5.97616C10.541 5.36092 9.75487 5.14901 9.13963 5.50448C8.5244 5.85995 8.31249 6.64608 8.66795 7.26131L16.0029 19.9557L12.9267 25.2808C12.5713 25.2125 12.1953 25.2398 11.833 25.3902C9.3242 26.4156 7.69725 25.5748 7.58104 25.5133C6.6787 24.9801 5.50975 25.2672 4.95604 26.1627C4.39549 27.0719 4.6826 28.2545 5.59178 28.815C5.81053 28.9517 7.21874 29.7584 9.41991 29.7584C10.5273 29.7584 11.833 29.5533 13.2959 28.9586C13.7744 28.7672 14.123 28.398 14.3213 27.9674C14.3623 27.9195 14.4033 27.8785 14.4306 27.8238L17.4863 22.5328L20.542 27.8238C20.5762 27.8785 20.6172 27.9195 20.6514 27.9674C20.8496 28.4049 21.1982 28.7672 21.6767 28.9586C23.1328 29.5601 24.4453 29.7584 25.5527 29.7584C27.7539 29.7584 29.1621 28.9517 29.3808 28.815C30.3037 28.2613 30.5908 27.0719 30.0303 26.1695Z",
    fill: "#14171F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHockey);
export default __webpack_public_path__ + "static/media/hockey.044afd2a5595f42e58f2903ff4d739c0.svg";
export { ForwardRef as ReactComponent };